import React from 'react';
import PropTypes from 'prop-types';

import Description from '../ListRowHelpers/Description/Description';
import Title from '../ListRowHelpers/Title/Title';

import './ListRowContent.css';

function ListRowContent({ title, description }) {
  return (
    <div className='ListRowContent-data'>
      <div className='ListRowContent-data-title'>
        {title.length > 0 && <Title data={title} />}
      </div>
      <div className='ListRowContent-data-description'>
        {description.length > 0 && <Description data={description} />}
      </div>
    </div>
  );
}

ListRowContent.propTypes = {
  title: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.oneOf(['text', 'label-value']),
      text: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  description: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.oneOf(['icon-text', 'avatar-text', 'label-value', 'text'])
        .isRequired,
      icon: PropTypes.element,
      text: PropTypes.string,
      avatar: PropTypes.element,
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

ListRowContent.defaultProps = {
  title: [],
  description: [],
};

export default ListRowContent;
